/**
 * OrdersPageShell — Feb 2026 Modern Theme Phase 3.
 *
 * Theme-aware switcher. Renders OrdersPageModern (lightly re-skinned
 * wrapper that applies .am-modern-scope + Modern canvas) when
 * `useTheme().isModern`, else the legacy OrdersPage. Both share the
 * same business logic — the Modern variant just adds the scope wrapper
 * so all `.am-cta` / `.am-card` CSS tokens activate.
 */
import { useTheme } from '../../context/ThemeContext';
import { OrdersPage } from './OrdersPage';
import { OrdersPageModern } from './OrdersPageModern';

export function OrdersPageShell() {
  const { isModern } = useTheme();
  return isModern ? <OrdersPageModern /> : <OrdersPage />;
}

export default OrdersPageShell;
